import { forwardRef, InjectionToken, Signal, Type } from '@angular/core';
import { Observable } from 'rxjs';

export interface ModuleConfigTabBusy {
  readonly isBusy: Signal<boolean>;
}

/** A tab whose changes the dialog footer saves and reverts. */
export interface ModuleConfigTabHost extends ModuleConfigTabBusy {
  readonly isDirty: Signal<boolean>;
  /** Emits whether the save went through. */
  save(): Observable<boolean>;
  discard(): void;
}

export const MODULE_CONFIG_TAB = new InjectionToken<ModuleConfigTabBusy>('MODULE_CONFIG_TAB');

/** The `forwardRef` is required: a tab reaches its own class before it is initialized. */
export const provideModuleConfigTab = (tab: () => Type<ModuleConfigTabBusy>) => ({
  provide: MODULE_CONFIG_TAB,
  useExisting: forwardRef(tab),
});

export interface ModuleConfigPanel extends ModuleConfigTabBusy {
  readonly savable?: Signal<boolean>;
  readonly isDirty?: Signal<boolean>;
  save?(): Observable<boolean>;
}

export const MODULE_CONFIG_PANEL = new InjectionToken<ModuleConfigPanel>('MODULE_CONFIG_PANEL');

export const provideModuleConfigPanel = (panel: () => Type<ModuleConfigPanel>) => ({
  provide: MODULE_CONFIG_PANEL,
  useExisting: forwardRef(panel),
});
